/**
 * This element is created and injected into the scrollable inner container
 * so it can stretch and match the width and height, effectively getting "free"
 * scrolling, rather than us trying to position elements and match them on scroll
 * and introducing a rubber band.
 */
export const SELECTIONS_CONTAINER_ELEMENT_ID = 'selections-overlay-container';

/**
 * The element that represents the current focus and is drawn on top of the associated
 * cell.
 */
export const SELECTIONS_FOCUS_CARAT_ELEMENT_ID = 'selections-focus-carat';
/**
 * This element is the main container that we base our highlights off of.
 * For highlights, we inject a container and match the size, allow pointer events
 * to passthrough, etc. When this is not mounted, we cannot have our machine running.
 */
export const SCROLLABLE_INNER_CONTAINER_ID = 'scrollable-inner-container';

/**
 * The main react application. This is used to listen to for mounting
 * highlights when the app is ready.
 */
export const APP_ELEMENT_ID = 'app';
